import React, {Component} from 'react';
import {Modal, Button} from 'react-bootstrap';
export default class SubmitModal extends Component {
  state = {formName:'', formEmail: ''}
  render() {
    const {props} = this;
  return <Modal show={props.showModal} onHide={props.toggleModal}>
  <Modal.Header closeButton>
    <Modal.Title>Terms & Conditions</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div
      style={{
        height: "200px",
        overflow: "scroll",
        padding: "5px",
        border: "solid 1px #eee"
      }}
    >
      <ul>
        <li>
          {" "}
          <strong>
            <em>
              <u>
                You represent and warrant that you legally own or have
                the right to reproduce the trademarks, logos, designs,
                or other identifiers (“Marks”) depicted on the
                template(s) associated with this order.
              </u>
            </em>
          </strong>{" "}
          You hereby grant to Sundesa (dba BlenderBottle) authorization
          to use the Marks in the production of thisorder. You authorize
          Sundesa to use images and physical copies of the products
          created by Sundesa for your company in Sundesa’s marketing and
          other promotional materials including its website. The use of
          the Marks is authorized until revoked in writing.
        </li>
        <li>
          {" "}
          You hereby agree to pay in full the charges associated with
          this order, and further agree to indemnify Sundesa (dba
          BlenderBottle) and hold it harmless for all claims and
          liability of any kind arising out of Sundesa's incorporation
          of any Marks, logos and other subjectmatter in and on any
          private label products made for you, including any fees, costs
          and expenses for defense of any claim related to or arising
          out of use of the requested private labeling.
        </li>
        <li>
          {" "}
          You agree not to take any steps to challenge the validity of
          any of Sundesa’s patents, patents pending, or patent
          applications, such as through IPR, re-examination or
          post-grant review.
        </li>
        <li>
          {" "}
          Extra fees may apply for items requested or changed after
          final order approval. Rush fees may apply for expedited
          orders.
        </li>
        <li>
          {" "}
          Any changes to the Marks after approving this form will result
          in an additional $200 change fee. Once production on the order
          has begun no changes will be allowed.
        </li>
        <li>
          {" "}
          All shipping dates are subject to change due to unforeseen
          production or shipping delays.
        </li>
        <li>
          {" "}
          Lift gate, residential delivery, or inside delivery services
          will result in additional fees not included in standard
          (ground) shipping charges. If any of these services are
          requested after the order has been processed, fees will be
          charged at the time of delivery.
        </li>
        <li>
          {" "}
          Warehouse fees may be applied if product is to be warehoused
          by Sundesa or stored for more than seven days from agreed upon
          ship date.
        </li>
      </ul>
    </div>
    <em>
      To accept the terms of this agreement, write your{" "}
      <strong>full name</strong> and email address in boxex below and click 'Submit Design'
    </em>
    <input
      placeholder="Your Full Name"
      onChange={e => {
        this.setState({ formName: e.target.value });
      }}
      value={this.state.formName}
      className={`form-control`}
      type="text"
    />
    <input
      placeholder="Your Email Address"
      onChange={e => {
        this.setState({ formEmail: e.target.value });
      }}
      value={this.state.formEmail}
      className={`form-control`}
      type="email"
    />
    <small>
      Your IP Address will be collected to authenticate your signature.
    </small>
  </Modal.Body>
  <Modal.Footer>
    <Button onClick={props.toggleModal}>Close</Button>
    <Button
      bsStyle="success"
      disabled={!this.state.formName || !this.state.formEmail}
      onClick={() => props.addToCart(this.state)}
    >
      Submit
    </Button>
  </Modal.Footer>
</Modal>;
}
}



// WEBPACK FOOTER //
// ./src/modal.js